<template>
    <app-header>
        <div class="relative flex w-full items-center gap-3">
            <div class="relative z-10 flex shrink-0 items-center gap-3">
                <toggler v-if="!sidebar.visible" class="inline-flex size-11 justify-center p-2" @click="sidebar.toggleVisible()" />
            </div>
            <div
                id="app-header-page-title"
                class="pointer-events-none absolute inset-y-0 right-40 left-[50px] flex min-w-0 items-center justify-start pr-1 pl-2 min-[768px]:right-auto min-[768px]:left-1/2 min-[768px]:w-[calc(100%-280px)] min-[768px]:max-w-[640px] min-[768px]:-translate-x-1/2 min-[768px]:justify-center min-[768px]:px-3"
            />
            <div class="relative z-10 ms-auto flex shrink-0 items-center gap-4">
                <header-nav>
                    <nav-item v-if="showTranslationKeyToggle" class="clickable text-white" title="Toggle translation keys" @click.stop="toggleKeys">
                        <icon name="cil-language" />
                    </nav-item>
                    <nav-item>
                        <connectivity-icon />
                    </nav-item>
                    <nav-item>
                        <notification-center />
                    </nav-item>
                    <nav-item>
                        <the-header-dropdown-account />
                    </nav-item>
                    <nav-item v-if="hasAnyPermission('asset.read')">
                        <button
                            class="btn btn-primary btn-extended inline-flex h-8 min-w-0 gap-[5px] px-2 hover:!bg-[var(--c-btn-bg)] focus:!bg-[var(--c-btn-bg)] max-[575px]:w-8 max-[575px]:px-1"
                            type="button"
                            @click.prevent="openQrScanner"
                        >
                            <icon name="cil-qr-code" />
                            <span class="max-[575px]:hidden">{{ trans('general.action.scan') }}</span>
                        </button>
                    </nav-item>
                </header-nav>
                <div v-if="logoUrl" class="hidden text-white xl:block">
                    <LogoCurie :height="28" :width="114" title="Curie Technologies Inc." />
                </div>
            </div>
        </div>
    </app-header>
</template>

<script setup>
import NotificationCenter from '@/Components/NotificationCenter/NotificationCenter.vue';
import HeaderNav from '@/Components/HeaderNav.vue';
import NavItem from '@/Components/NavItem.vue';
import ConnectivityIcon from '@/Components/ConnectivityIcon.vue';
import TheHeaderDropdownAccount from '@/Containers/HeaderDropdownAccount.vue';
import AppHeader from '@/Components/AppHeader.vue';
import { useSidebarStore } from '@/stores/sidebar.js';
import Toggler from '@/Components/Toggler.vue';
import { showTranslationsKeys } from '@/mixins/i18n.js';
import { useCurieIdScanner } from '@/composables/useCurieIdScanner.ts';
import { useConnectivityFlash } from '@/composables/useConnectivityFlash';
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import LogoCurie from '../../icons/LogoCurie.vue';
import { hasAnyPermission } from '@/mixins/hasAnyPermission.js';

const page = usePage();
const sidebar = useSidebarStore();
const { openForAssetSearch: openQrScanner } = useCurieIdScanner();
useConnectivityFlash();

const showTranslationKeyToggle = computed(() => {
    return page.props.enableTranslationKeySwitch;
});

const toggleKeys = () => {
    showTranslationsKeys.value = !showTranslationsKeys.value;
};
const logoUrl = computed(() => page.props.settings.big_logo_url);
</script>
